import React,{useEffect} from "react";

import "./Clubs.css";
import { Clubscard,Backtotop,Modal, Underline,Videocard } from "../../widgets";
import { Heroimagecarousal} from "../../components";
import { Clubs_info ,clubs_heroimage_carousalinfo} from "../../constants/Clubs";


const Clubs = () => {
  useEffect(() => {
    document.title = 'ACCET-Clubs';
  }, []);
  return (
    <div>
      <Backtotop/>
    <div className="alumni_body_clubs">
        
         <Heroimagecarousal
          key={clubs_heroimage_carousalinfo.id}
          title={clubs_heroimage_carousalinfo.title}
          img_list={clubs_heroimage_carousalinfo.img_list}
        />
         {/*<Slideshow images={slideshow_imgs_club} />*/}
        <div className="container clubs-menu_clubs">
          <a href="#about" className="lin_clubs">
            About
          </a>
          {/* <a href="#contribution" className="lin">
            Contributions
          </a> */}
          <a href="/Clubs/ClubsActivity" className="lin_clubs">
            Club Activity Reports
          </a>
        </div>
        </div>

        <div className="divider_clubs"></div>

        
          <div className="abt_clubs">
     
        <div className="dsc_clubs">
              We offer our students a vital avenue for holistic growth, enabling them to pursue passions, refine skills, and build a sense of belonging. Through diverse club activities, students develop not only academically but also in essential life skills like teamwork leadership, and communication, resulting in a well-rounded education. These experiences nurture socially aware, confident, and adaptable individuals prepared for real-world challenges.
            </div>
      </div>

      {Clubs_info.map((item) => (
        <Clubscard
          key={item.id}
          logoimg={item.logoimg}
          title={item.title}
          maillink={item.maillink}
          instalink={item.instalink}
          para={item.para}
          staff={item.staff}
          staffdesi={item.staffdesi}
          student={item.student}
          studentdesi={item.studentdesi}
          infolink={item.infolink}
           videolink={item.videolink} 
        />
      ))}
      
    </div>
  );
};

export default Clubs;
